module.exports = __webpack_public_path__ + "static/media/AAN2_EDITSINGLE.cf853323.mp4";